module.exports = __webpack_public_path__ + "img/stuff-logo-active.342ef599.svg";